// react-native-pdf for the web: the browser's built-in PDF viewer in an
// iframe. Page count isn't available, so onLoadComplete reports one page.
import React from 'react';
import {View} from 'react-native';

export default function Pdf({source, style, onLoadComplete, onError}) {
  const uri = source?.uri;
  return (
    <View style={style}>
      {!!uri &&
        React.createElement('iframe', {
          src: uri,
          title: 'PDF',
          style: {border: 0, width: '100%', height: '100%'},
          onLoad: () => onLoadComplete?.(1),
          onError: () => onError?.(new Error('Could not load PDF')),
        })}
    </View>
  );
}
